export var tariff = {
  defaultNextBillingDateText: 'оплата спишется',
  sharingText: {
    master: 'делюсь тарифом',
    slave: 'общий с'
  },
  unifiedTariff: {
    title: 'общий тариф',
    text: 'другой номер делится с вами своим тарифом — гб, минуты и смс для вас бесплатные. вы платите только за роуминг, подключенные услуги и подписки',
    btnText: 'вернуться'
  },
  manage: {
    btnTitle: 'Настроить тариф'
  },
  error: 'тариф не загрузился — нажмите, чтобы обновить'
};